<template>
  <div class="report">
    <div class="content">
      <d-search
        class="d-search"
        :searchData="searchData"
        @searchEvent="searchEvent"
        @openEvent="openEvent"
        @exportEvent="exportEvent"
      />
      <d-lable :columnData="columnData" :tableData="tableData" @viewEvent="viewEvent"></d-lable>
      <d-paging :pager="pager" @change="getItemList" />
    </div>
  </div>
</template>

<script>
import DSearch from "../../../components/d-search";
import DLable from "../../../components/d-table";
import DPaging from "../../../components/d-paging";
import { options } from "../../../components/options";
import { onDownload, filterDayDate, disabledDayDate  } from "@/utils/utils";
export default {
  data() {
    return {
      pager: {
        count: 0,
        page: 1,
        rows: 10
      },
      maxDate: null,
      minDate: null,
      searchData: {
        searchItem: [
          {
            label: "状态",
            value: "status",
            type: "commonSelect",
            placeholder: "",
            options: []
          },
          {
            label: "选择店铺",
            value: "shopIdList",
            type: "linkageSelect",
            dateType: "month",
            placeholder: "",
            options: options,
            optionProps: {
              value: "name",
              label: "name",
              children: "childList"
            }
          }
        ],
        searchBtn: {
          queryBtn: true,
          exportBtn: true,
          isOpen: {
            type: true,
            open: true
          }
        },
        params: {
          status: null,
          saleDate: []
        }
      },
      columnData: [
        { prop: "id", label: "编号" },
        { prop: "floor", label: "楼层" },
        { prop: "shopNo", label: "店铺号" },
        { prop: "shopName", label: "店铺名称" },
        { prop: "saleTime", label: "销售日期" },
        { prop: "typeText", label: "销售状态" },
        { prop: "status", label: "状态" },
        { prop: "commitUser", label: "提交人" },
        { prop: "submitTime", label: "提交时间" },
        {
          prop: "operate",
          label: "操作",
          type: {
            viewBtn: true
          }
        }
      ],
      flootList: [],
      tableData: []
    };
  },
  computed: {},
  components: {
    DSearch,
    DLable,
    DPaging
  },
  created() {
    this.setInitDate()
    this.init();
  },
  mounted() {},
  methods: {
    setInitDate () {
      const date = new Date()
      const endDate = this.$reconava.parseTime(date, '{y}-{m}-{d}')
      const startDate = this.$reconava.parseTime(date - 365*24*60*60*1000, '{y}-{m}-{d}')
      this.searchData.params.saleDate = [startDate, endDate]
    },
    /**
     * 搜索按钮点击
     */
    searchEvent() {
      this.reportSaleList();
    },
    /**
     * 展开收起按钮
     */
    openEvent(status) {
      this.searchData.searchBtn.isOpen.open = status;
      if (!this.searchData.searchBtn.isOpen.open) {
        const item = {
          label: "提交时间",
          value: "commitTime",
          type: "commonDate",
          startPlaceholder: "开始时间",
          endPlaceholder: "结束时间"
        };
        const floot = {
          label: "楼层",
          value: "floot",
          type: "commonSelect",
          placeholder: "",
          options: this.flootList
        };
        const name = {
          label: "提交人",
          value: "name",
          type: "commonInput",
          dateType: "month",
          placeholder: "请输入"
        };
        this.searchData.searchItem.push(item, floot, name, {
          label: '销售日期',
          value: 'saleDate',
          type: 'scopeDate',
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          options: {
            onPick: filterDayDate.bind(this),
            disabledDate: disabledDayDate.call(this, 365*24*60*60*1000)
          }
        },{
          label: '销售状态',
          value: 'type',
          type: 'commonSelect',
          placeholder: '',
          options: [
            { label: '销售', value: 1 },
            { label: '退货', value: 2 }
          ],
        });
      } else {
        this.searchData.searchItem = this.searchData.searchItem.slice(0, 2);
      }
    },
    /**
     * 导出
     */
    exportEvent() {
      const [startSaleTime, endSaleTime] = this.searchData.params.saleDate || []
      const obj = {
        status: this.searchData.params.status,
        submitTime: this.searchData.params.commitTime,
        shop: this.searchData.params.shopIdList
          ? this.searchData.params.shopIdList[
              this.searchData.params.shopIdList.length - 1
            ]
          : null,
        floor: this.searchData.params.floot,
        name: this.searchData.params.name,
        beginSaleTime: startSaleTime || null,
        endSaleTime: endSaleTime || null,
        type: this.searchData.params.type || null
      };
      this.$api.mentapi.reportSaleExport(obj).then(res => {
        let { headers, data } = res;
        onDownload(headers, data);
      });
    },
    viewEvent(column) {
      this.$router.push({
        path: "/statement/reportInfo",
        query: { id: column.id }
      });
    },
    /**
     * 查询请求
     */
    getItemList() {
      this.reportSaleList();
    },
    /**
     * 获取选择店铺列表
     */
    getShopList() {
      this.$api.shopapi.getShopList().then(({ data, code }) => {
        if (code == 200) {
          this.childList = data.childList;
          const child = [
            {
              id: data.id,
              name: data.name,
              childList: data.childList
            }
          ];
          this.searchData.searchItem.forEach(item => {
            if (item.type === "linkageSelect") {
              item.options = child;
            }
          });
        }
      });
    },
    /**
     * 获取状态列表
     */
    getStatusList() {
      this.$api.sysapi
        .getStatusList({ dictType: "report_status" })
        .then(({ code, data }) => {
          this.searchData.searchItem[0].options = data.list.map(item => ({
            value: item.dictValue,
            label: item.dictLabel
          }));
        });
    },
    /**
     * 获取楼层列表
     */
    getFloorList() {
      this.$api.sysapi.getfloorList().then(({ code, data }) => {
        if (code === 200) {
          this.flootList = data.map(item => ({
            value: item.code,
            label: item.name
          }));
        }
      });
    },
    /**
     * 上报销售列表
     */
    reportSaleList(shop) {
      const [startSaleTime, endSaleTime] = this.searchData.params.saleDate || []
      const obj = {
        pageNum: this.pager.page,
        pageSize: this.pager.rows,
        status: this.searchData.params.status,
        submitTime: this.searchData.params.commitTime,
        shop: this.searchData.params.shopIdList
          ? this.searchData.params.shopIdList[
              this.searchData.params.shopIdList.length - 1
            ]
          : null,
        floor: this.searchData.params.floot,
        name: this.searchData.params.name,
        beginSaleTime: startSaleTime || null,
        endSaleTime: endSaleTime || null,
        type: this.searchData.params.type || null
      };
      this.$api.checkapi
        .reportSaleList(shop || obj)
        .then(({ code, data, msg }) => {
          if (code === 200) {
            this.pager.count = data.total;
            this.tableData = data.list.map(item => ({
              ...item,
              sex: item.sex === "F" ? "女性" : item.sex === "M" ? "男性" : "无",
              status:['驳回','通过','待审核','撤销'][item.status],
              saleTime: item.saleTime + (item.period ? ' ' + item.period : '')
            }));
          } else {
            this.$message.error(msg);
          }
        });
    },
    /**
     * init 初始化
     */
    init() {
      this.getShopList();
      this.getFloorList();
      this.getStatusList();
      this.reportSaleList();
    }
  },
  watch: {}
};
</script>
<style lang="scss" scoped>
.report {
  width: 100%;
  .title {
    width: 100%;
    height: 105px;
    background-color: #fff;
    display: flex;
    .sort:nth-child(-n + 2) {
      .border-left {
        border-right: 1px solid #ccc;
      }
    }
    .sort {
      width: 33.33%;
      height: 100%;
      text-align: center;
      .border-left {
        margin-top: 20px;
        span {
          display: inline-block;
          font-weight: 400;
          font-style: normal;
          color: #999999;
        }
        p {
          display: inline-block;
          font-weight: 400;
          font-style: normal;
          font-size: 24px;
          color: #1b1b1b;
          margin-top: 10px;
        }
      }
    }
  }
  .content {
    display: flex;
    flex-direction: column;
    flex:1;
    width: 100%;
    box-sizing: border-box;
    background-color: #fff;
    padding: 0 30px;
    text-align: center;
    .d-search {
      padding: 30px 0;
    }
    .el-table {
      margin-bottom: 20px;
      flex: 1;
      overflow-y: auto;
    }
  }
}
</style>
